.assetLogoWithLabel {
  --ixf-asset-logo-size: 32px;

  &.size {
    &-x-small {
      --ixf-asset-logo-size: 16px;
    }

    &-small {
      --ixf-asset-logo-size: 24px;
    }
  }

  &.isSkeleton {
    width: 100%;

    .logo {
      width: var(--ixf-asset-logo-size);
      flex: 0 0 auto;
    }

    .label {
      flex: 1 1 100%;
    }
  }
}
